import { Box, Button, Text } from '@chakra-ui/react';
import React from 'react';

const Header = ({ setTab, currentTab }) => {
  const handleTabChange = e => {
    setTab(e.target.id);
  };
  return (
    <>
      <Text fontSize="34px" color="#1b254b" fontWeight="700">
        Smart Notes
      </Text>
      <Box mt="0.6rem" display={{ base: 'block', md: 'none' }}>
        <Button
          id="notes-tab"
          ml="0.9rem"
          onClick={handleTabChange}
          isActive={currentTab === 'notes-tab'}
        >
          Notes
        </Button>
        <Button
          id="doubts-tab"
          ml="0.9rem"
          onClick={handleTabChange}
          isActive={currentTab === 'doubts-tab'}
        >
          Ask Doubts
        </Button>
      </Box>
    </>
  );
};

export default Header;
